import {
  uploadFilesWithProgress,
  UPLOAD_PROCESSING_PROGRESS,
} from 'utils/uploadFilesWithProgress';

export const CREATE_API_PROGRESS = UPLOAD_PROCESSING_PROGRESS;
export const UPLOAD_PROGRESS_MAX = 85;

export const mapProgressRange = (start, end, percent) =>
  Math.round(start + ((end - start) * percent) / 100);

export const resolveUploadedImageUrl = (value) => {
  if (typeof value === 'string') {
    return value;
  }
  if (value?.original) {
    return value.original;
  }
  return null;
};

export const uploadFileWithMappedProgress = async ({
  file,
  accessToken,
  rangeStart,
  rangeEnd,
  thumbnailRequired,
  onProgress,
  signal,
}) => {
  const urls = await uploadFilesWithProgress({
    files: [file],
    accessToken,
    thumbnailRequired,
    onProgress: ({ phase, percent }) => {
      onProgress?.({
        phase,
        percent: mapProgressRange(rangeStart, rangeEnd, percent),
      });
    },
    signal,
  });

  const uploadedUrl = resolveUploadedImageUrl(urls?.[0]);
  if (!uploadedUrl) {
    throw new Error('Upload failed');
  }

  return uploadedUrl;
};

export const normalizePayloadValue = (value) => (value === '' ? null : value);

export const isHttpUrl = (value) =>
  typeof value === 'string' && /^https?:\/\//i.test(value);

export const resolveExistingImageFromFileList = (fileList) => {
  const file = Array.isArray(fileList) ? fileList[0] : null;
  if (!file) {
    return { file: null, url: null };
  }
  if (file.originFileObj) {
    return { file: file.originFileObj, url: null };
  }
  if (isHttpUrl(file.url)) {
    return { file: null, url: file.url };
  }
  return { file: null, url: null };
};
